import { useState } from 'react'

interface UsePaginationReturn {
  pageNumber: number
  handleNextPage: (totalCount: number) => void
  handlePreviousPage: () => void
}

export const usePagination = (): UsePaginationReturn => {
  const [pageNumber, setPageNumber] = useState(1)

  const handleNextPage = (totalCount: number) => {
    if (totalCount > pageNumber) {
      setPageNumber(pageNumber + 1)
    }
  }

  const handlePreviousPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1)
    }
  }

  return {
    pageNumber,
    handleNextPage,
    handlePreviousPage,
  }
}
